import React, { useRef, useEffect, useState } from 'react';

const RegularPageLayout: React.FC<{ header: React.ReactNode, content: React.ReactNode }> = ({ header, content }) => {
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(80);

    useEffect(() => {
        const updateHeight = () => {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight + 16);
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div className='ml-4 mr-4'>
            <div ref={headerRef} className="fixed left-0 top-[94px] right-0 bg-white pt-4 pb-4 pl-4 pr-4 z-40">
                {header}
            </div>
            <div style={{ paddingTop: `${headerHeight}px` }} className="pb-10">
                {content}
            </div>
        </div>
    );
};

export default RegularPageLayout;